module.exports = __webpack_public_path__ + "img/quintuple.f638244d.png";